(function() {
	'use strict';
	var $ = avm.require('cash'),
		userAgent = navigator.userAgent.toLowerCase(),
		html = $(document.documentElement),
		brandName,
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$graph = $('.js-graph'),
		$secondaryNav = $('#nav-wrap'),
		$media1waypoint = $('#freeup'),
		$media2waypoint = $('#optimize'),
		$media3waypoint = $('#tuneup'),
		$media4waypoint = $('#boost-battery'),
		$beforeFooter = $('#beforeFooterTeaser'),
		$navLinks = $('.nav-link'),
		setActive = function($this) {
			$navLinks.removeClass('active');
			$this.addClass('active');
		},
		navItemsActivation = function() {
			if (waypoints($('#nav-wrap'), null, null, true)) {
				setActive($('#nav-wrap-tab1'));
			}
			if (waypoints($media2waypoint, null, null, true)) {
				setActive($('#nav-wrap-tab2'));
			}
			if (waypoints($media3waypoint, null, null, true)) {
				setActive($('#nav-wrap-tab3'));
			}
			if (waypoints($media4waypoint, null, null, true)) {
				setActive($('#nav-wrap-tab4'));
			}
		};

	$window.on('resize scroll', navItemsActivation);

	// Secondary navigation: Sticky navigation
	$window.on('resize scroll', function() {
		if (waypoints($('#sticky-waypoint'), null, null, true)) {
			$secondaryNav.addClass('is-sticky');
		} else {
			$secondaryNav.removeClass('is-sticky');
			$navLinks.removeClass('active');
		}

		if (waypoints($beforeFooter, null, null, true)) {
			$secondaryNav.addClass('hidden');
		} else {
			$secondaryNav.removeClass('hidden');
		}
		if (waypoints($graph, null, $window.height() - 100)) {
			$graph.addClass('animate');
		}
	});

	// User agent strings brand detection - Huawei
	if (/(android.+\s(nexus\s6p|vog-[at]?l\d\d|ele-[at]?l[x\d]\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?))|(d\/huawei([\w\s-]+)[;\)])|(HuaweiBrowser)/ig.test(userAgent)) {
		brandName = 'huawei';
		html.addClass('js-' + brandName);
	}
})();
